<template>
  <div class="popup-box-wrap" :class="[ownClass ? ownClass : '']" v-if="showPopBox">
    <transition name="drawerSlideInUp">
      <div class="main-box" v-if="animate">
        <i class="close-btn" v-if="!hideCloseBtn" @click.self="closePopup"></i>
        <div class="main customer-view">
          <div :is="popupType" :propData="popupInner" @save="save" @saveAndAction="saveAndAction"></div>
        </div>
        <div class="btn-box operator-footer-btn-group">
          <el-button @click="canceled" class="is-disabled" v-if="cancelButtonText">
            {{ cancelButtonText }}
          </el-button>
          <el-button @click="confirmed" v-if="confirmButtonText">
            {{ confirmButtonText }}
          </el-button>
          <el-button @click="validated" v-if="validateButtonText">
            {{ validateButtonText }}
          </el-button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script type="text/babel">
/*
*@author zhaoyr
*
* @param {string}     loadingText    要显示的文字      非必传 需要多行排列时，加上换行识别符号
* @param {string}     ownClass       自定义容器class   非必传
* 
*
* 使用方法 this.popUp({ popupType: "userAuth", content: {title: "", messageText: ""}, confirmedAction: function () {}, canceledAction: function () {} })
*
*/

import userAuth from "./content/userAuth";
import userInput from "./content/userInput";
import cancelCreditCheck from "./content/cancelCreditCheck";
import showData from "./content/showData";
import warmPrompt from "./content/warm_prompt.vue";
import selectStb from "./content/selectStb";
import proBizList from "./content/proBizList";

export default {
  components: {
    userAuth: userAuth,
    userInput: userInput, //柜员输入
    cancelCreditCheck: cancelCreditCheck,//信用销户检查
    showData: showData, //资料对比
    warmPrompt: warmPrompt,
    selectStb: selectStb, //三板确权展示多条退市持仓信息
    proBizList: proBizList, //产品开户多条流水
  },
  data () {
    return {
      animate: false,
      //popup
      showPopBox: false,
      ownClass: "",
      popupType: "default",
      popupInner: {},
      cancelButtonText: "不确认",
      confirmButtonText: "确认",
      validateButtonText: "",
      hideCloseBtn: false,
      saveObj: {}, //用于数据保存
    };
  },
  mounted () {
    this.animate = true;
  },
  methods: {
    closePopup () {
      this.showPopBox = false;
      window.popCloseAction = "";
    },
    confirmed () {
      let saveObj = _.cloneDeep(this.saveObj) || {};
      this.showPopBox = false;
      if (this.confirmedAction) {
        this.confirmedAction(saveObj);
      }
    },
    canceled () {
      this.showPopBox = false;
      if (this.canceledAction) {
        this.canceledAction();
      }
    },
    async validated () {
      let saveObj = _.cloneDeep(this.saveObj) || {},
        flag = this.validateAction && await this.validateAction(saveObj);
      if (flag) {
        this.showPopBox = false;
      }
    },
    save (val) {
      this.saveObj = val;
    },
    saveAndAction (val) {
      this.save(val[0]);
      if (val[1] && val[1] == "confirm") {
        this.confirmed();
      }
    }
  },
  watch: {
    showPopBox (val) {
      this.saveObj = {};
      consoleLog("状态", val);
      if (val) {
        window.popCloseAction = this.closePopup;
      }
    }
  },
  beforeDestroy () {
    this.saveObj = {};
    window.popCloseAction = "";
  }
};
</script>

<style lang="less">
.popup-box-wrap {
  position: fixed;
  z-index: 2020;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background-color: rgba(0, 0, 0, 0.8);
  box-sizing: border-box;
  .main-box {
    height: 100%;
    width: 80%;
    margin: 20% 10%;
    display: flex;
    flex-direction: column;
    position: relative;
    background-color: #fff;
    border-radius: 10px 10px 0 0;
    .close-btn {
      position: absolute;
      top: -100px;
      right: 0px;
      display: block;
      width: 70px;
      height: 70px;
      background: url("~@img/select_cust_type/01person/icon_guanbi.png");
    }
    .main {
      flex-grow: 1;
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      border-radius: 10px 10px 0 0;
      // background: #fff url("~@img/flow_reuse/inner_bg/bg_beijingwenli.png")
        // repeat top;
      &.customer-view {
        border-bottom: 1px solid #848484;
        flex: none;
        padding: 0;
        width: 100%;
        overflow: hidden;
      }
    }
    .btn-box {
      flex: 0 0 130px;
      display: flex;
      flex: 0;
      align-items: center;
      justify-content: center;
      margin: 0;
      background: #fff;
      .el-button {
        + .el-button {
          margin-left: 40px;
        }
        &.btn--danger {
          background: rgba(255, 255, 255, 1);
          border: 2px solid rgba(193, 17, 17, 1);
          color: rgba(193, 17, 17, 1);
        }
        &.is-disabled {
          background: #fff;
          color: #3c5ce2;
          border: 2px solid #5172f6;
        }
        width: 220px;
        height: 80px;
        background: linear-gradient(
          45deg,
          rgba(53, 86, 221, 1),
          rgba(70, 103, 233, 1)
        );
        border-radius: 4px;
        font-size: 32px;
        color: #fff;
        &.el-button__home {
          background: #ffffff;
          color: rgba(53, 86, 221, 1);
          border-color: rgba(53, 86, 221, 1);
        }
      }
    }
  }
}

.drawerSlideInUp-enter-active {
  animation: drawer-slide-in-up 0.5s;
}
.drawerSlideInUp-leave-active {
  animation: drawer-slide-in-up 0.5s reverse;
}
@keyframes drawer-slide-in-up {
  0% {
    transform: translateY(1400px);
  }
  100% {
    transform: translateY(0px);
  }
}
</style>


// WEBPACK FOOTER //
// src/lib/ui/default/popup/src/popup.vue